import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import journeys from "../static/data/journeys.js";
import LazyImage from "../components/LazyImage.js";
import useWindowDimensions from "../hooks/useWindowDimensions.js";
import "../sass/main.scss";
import AnimatedContent from "../animatedComponents/AnimatedContent.js";
import { SignatureJourneys } from "../components/SignatureJourneys.js";

export const ProductNew = () => {
    const [country, setCountry] = useState(null);
    const [details, setDetails] = useState(null);
    const { destination, subDestination } = useParams(); // Get both params
    const [mainImage, setMainImage] = useState(null);
    const navigate = useNavigate();
    const { width } = useWindowDimensions();


    useEffect(() => {
        if (details) {
            setMainImage(details.images.main); // Set the main image when details change
        }
    }, [details]);

    useEffect(() => {
        // Find the country object that matches the destination
        setCountry(journeys.find((dest) => dest.country === destination.slice(1)));

        if (country) {
            if (subDestination) {
                // If a subDestination exists, find the specific tour
                setDetails(
                    country.tours.find(
                        (subDest) =>
                            subDestination.slice(1).toLowerCase() === subDest.destination.toLowerCase()
                    )
                );
            } else {
                // If no subDestination exists, load the first tour (or any default behavior)
                setDetails(country.tours[0]);
            }
        }
    }, [country, destination, subDestination]);


    const navToBooking = useCallback(() => {
        navigate("/contact", {
            state: {
                country: country && country.country,
                destination: details && details.destination
            }
        })
    }, [country, details, navigate]);

    if (!details) return null; // Prevent rendering if no details are loaded

    return (
        <div className="prod-container">
            <div className="prod-intro">
                <div className="prod-intro-left">
                    <LazyImage
                        imgOnly={true}
                        src={mainImage}
                        className="prod-intro-left-image"
                    />
                </div>
                <div className="prod-intro-right">
                    <h1 style={{ marginTop: "1rem" }}>
                        {details.description}
                    </h1>
                    <h2 style={{ fontFamily: '"Raleway", sans-serif', color: "#000", fontWeight: "500", marginTop: width > 600 ? "-0.5rem" : "0" }}>{details.sub_description}</h2>
                    {details.info.map((info, index) => (
                        <p key={index}>{info}</p>
                    ))}

                    <div className="best-time-container">
                        <h1 style={{ color: "#97789b" }}>Best Time To Visit:</h1>
                        <p>{details.bestTime}</p>
                    </div>
                </div>
            </div>

            <AnimatedContent className="it-highlights">
                {width < 600 && (
                    <AnimatedContent className="outro-image-container">
                        <LazyImage imgOnly={true} src={details.images.outro} alt={`WanderLuxe_Product_Outro`} />
                    </AnimatedContent>
                )}
                <h1 style={{ marginTop: width < 600 && "3rem" }}>Itinerary highlights</h1>
                {details.itHighlights.map((itObj, index) => (
                    <div style={{ margin: width > 600 && "3rem 0" }} key={index}>
                        <p style={{ margin: (index === 0 && width < 600) && "0 0 1rem 0" }}>
                            <b style={{ fontfamily: '"Raleway", sans-serif', fontWeight: 700 }}>{itObj.highlight}  </b> <br />{itObj.description}
                        </p>
                    </div>
                ))}

                <div style={{ height: "2vh" }} />

                <div className="it-highlights-image-row">
                    <div className="it-highlights-image-row-col">
                        <LazyImage
                            imgOnly={true}
                            alt="WanderLuxe_Enquire_Now_"
                            src={details.images.it_1}
                            className="it-highlights-image-row-col-img"
                        />
                        <div>
                            <button onClick={navToBooking} className="button-greyish">Enquire Now</button>
                        </div>

                    </div>
                    <div className="it-highlights-image-row-col">
                        <LazyImage
                            imgOnly={true}
                            alt="WanderLuxe_Itinerary"
                            src={details.images.it_2}
                            className="it-highlights-image-row-col-img"
                        // style={{ objectPositionX: "-1rem" }}
                        />
                        <div>
                            <button className="button-greyish" >
                                <a href={details.itPdf} style={{ textDecoratwion: "none" }} download={details.destination} alt="">
                                    DOWNLOAD ITINERARY
                                </a>
                            </button>
                        </div>
                    </div>
                </div>

            </AnimatedContent>

            {width > 600 && (<AnimatedContent className="outro-image-container">
                <LazyImage imgOnly={true} src={details.images.outro} alt={`WanderLuxe_Product_Outro`} />
            </AnimatedContent>)}

            <div className="explore-more-section">
                <h1 style={{ marginTop: "2rem" }}>Explore More Destinations</h1>
                <SignatureJourneys currentJourney={details.destination} />
            </div>
        </div>
    );
};
